import { useEffect } from 'react';
import {
  PartialEventWithRequiredAction,
  useSendAnalytics,
} from 'src/components/AnalyticsProvider/useSendAnalytics';

export interface UseAddNewPeopleSuccessModalAnalytics {
  sendAnalyticsBefore: (
    cb: () => void,
    eventData: PartialEventWithRequiredAction
  ) => void;
}

export const useAddNewPeopleSuccessModalAnalytics =
  (): UseAddNewPeopleSuccessModalAnalytics => {
    const { sendAnalytics, sendAnalyticsBefore } = useSendAnalytics({
      eventcategory: 'self-service management tool_people',
      eventlabel: 'success',
    });

    useEffect(() => {
      sendAnalytics({ eventaction: 'success module_impression' });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
      sendAnalyticsBefore,
    };
  };
